// Common HACCP consultant header — auto-fills from logged user
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { PenLine, User } from 'lucide-react';

export default function HaccpConsultantHeader({ pdv, dateLabel }) {
  const { user } = useAuth();
  const titolo = user?.titolo_professionale || '';
  const name = user?.full_name || '—';
  const firma = user?.firma_autografa_url || '';
  const today = dateLabel || new Date().toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });

  return (
    <Card className="bg-gradient-to-r from-orange-50 to-amber-50 border-orange-200" data-testid="haccp-consultant-header">
      <CardContent className="py-3 flex flex-wrap items-center gap-4">
        <div className="flex items-center gap-2">
          <User className="w-5 h-5 text-orange-600" />
          <span className="text-xs text-gray-500 uppercase">Consulente HACCP</span>
          <span className="font-semibold">{titolo} {name}</span>
        </div>
        {pdv && (
          <Badge variant="outline" className="border-orange-300">
            UL: {pdv.name} · {pdv.city || ''}
          </Badge>
        )}
        <Badge variant="outline" className="border-gray-300">
          Data: {today}
        </Badge>
        {firma ? (
          <div className="flex items-center gap-2">
            <PenLine className="w-4 h-4 text-emerald-600" />
            <span className="text-xs text-emerald-700">Firma autografa pronta</span>
            <img src={firma} alt="firma" className="h-6 max-w-[80px] object-contain" />
          </div>
        ) : (
          <span className="text-xs text-amber-700">⚠ Firma autografa non caricata · vai a Profilo per caricarla</span>
        )}
      </CardContent>
    </Card>
  );
}
